import axios from "axios";
import { supabase } from "./supabaseClient"; // Importar o cliente Supabase

// Obter API URL do sistema de configuração dinâmica
const getApiUrl = () => {
  return (
    window.ENV?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    "/api"
  );
};

const API_URL = getApiUrl();

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const productionService = {
  async createProductionOrder(orderData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para criar ordens de produção."
        );
      }

      const response = await axiosInstance.post(
        `/production/orders`,
        orderData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao criar ordem de produção"
        );
      }
      throw error;
    }
  },

  async getProductionOrders(filters = {}) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar ordens de produção."
        );
      }

      const response = await axiosInstance.get(`/production/orders`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: filters,
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar ordens de produção"
        );
      }
      throw error;
    }
  },

  async getProductionOrderById(id) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar detalhes da ordem de produção."
        );
      }

      const response = await axiosInstance.get(`/production/orders/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message ||
            "Erro ao buscar detalhes da ordem de produção"
        );
      }
      throw error;
    }
  },

  async updateProductionOrder(id, orderData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para atualizar ordens de produção."
        );
      }

      const response = await axiosInstance.put(
        `/production/orders/${id}`,
        orderData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao atualizar ordem de produção"
        );
      }
      throw error;
    }
  },

  async updateProductionOrderItems(id, items) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para atualizar itens da ordem de produção."
        );
      }

      const response = await axiosInstance.put(
        `/production/orders/${id}/items`,
        { items },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao atualizar itens da ordem de produção"
        );
      }
      throw error;
    }
  },

  async createProductionLot(lotData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para criar lotes de produção."
        );
      }

      const response = await axiosInstance.post(`/production/lots`, lotData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao criar lote de produção"
        );
      }
      throw error;
    }
  },

  async getProductionLots(filters = {}) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar lotes de produção."
        );
      }

      const response = await axiosInstance.get(`/production/lots`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: filters,
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar lotes de produção"
        );
      }
      throw error;
    }
  },

  async updateProductionLot(id, lotData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para atualizar lotes de produção."
        );
      }

      const response = await axiosInstance.put(
        `/production/lots/${id}`,
        lotData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao atualizar lote de produção"
        );
      }
      throw error;
    }
  },

  async updateProductionLotNumber(id, lotNumber) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para atualizar o número do lote."
        );
      }

      const response = await axiosInstance.put(
        `/production/lots/${id}/number`,
        { lot_number: lotNumber },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao atualizar número do lote"
        );
      }
      throw error;
    }
  },

  async updateProductionLotActualDate(id, actualProductionDate) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para atualizar a data real de produção."
        );
      }

      const response = await axiosInstance.put(
        `/production/lots/${id}/actual-date`,
        { actual_production_date: actualProductionDate },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao atualizar a data real de produção"
        );
      }
      throw error;
    }
  },

  async getUserFullName(userId) {
    try {
      const { data, error } = await supabase.rpc("get_user_full_name_by_id", {
        p_user_id: userId,
      });
      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Erro ao buscar nome do usuário:", error);
      return null;
    }
  },

  async updateProductionLotQuality(lotId, qualityGrade, userId) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para atualizar a qualidade do lote."
        );
      }

      const response = await axiosInstance.put(
        `/production/lots/${lotId}/quality`,
        { p_quality_grade: qualityGrade, p_responsible_user_id: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao atualizar a qualidade do lote"
        );
      }
      throw error;
    }
  },

  async rejectProductionItem(orderId, productId, actualProducedQuantity, quantityProducedKg) {
    try {
      console.log('Frontend: Enviando rejeição para:', { orderId, productId, actualProducedQuantity, quantityProducedKg });

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para rejeitar o item."
        );
      }

      console.log('Frontend: URL da chamada:', `/production/orders/${orderId}/items/${productId}/reject`);
      console.log('Frontend: Payload:', { actual_produced_quantity: actualProducedQuantity, quantity_produced_kg: quantityProducedKg });

      const response = await axiosInstance.put(
        `/production/orders/${orderId}/items/${productId}/reject`,
        {
          actual_produced_quantity: actualProducedQuantity,
          quantity_produced_kg: quantityProducedKg,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('Frontend: ✅ Resposta da API de rejeição:', response.data);
      console.log('Frontend: Status HTTP:', response.status);

      return response.data;
    } catch (error) {
      console.error('Frontend: ❌ ERRO na rejeição:', error);
      if (error.response) {
        console.error('Frontend: Resposta do erro:', error.response.data);
        throw new Error(
          error.response.data.message || "Erro ao rejeitar o item"
        );
      }
      throw error;
    }
  },

  async getProductRejections(productId) {
    try {
      console.log('Frontend: Buscando rejeições do produto:', productId);

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar rejeições."
        );
      }

      console.log('Frontend: URL da chamada:', `/production/products/${productId}/rejections`);
      const response = await axiosInstance.get(
        `/production/products/${productId}/rejections`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar rejeições do produto"
        );
      }
      throw error;
    }
  },

  async getProductProductions(productId) {
    try {
      console.log('Frontend: Buscando produções do produto:', productId);

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar produções."
        );
      }

      console.log('Frontend: URL da chamada:', `/production/products/${productId}/productions`);
      const response = await axiosInstance.get(
        `/production/products/${productId}/productions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar produções do produto"
        );
      }
      throw error;
    }
  },

  async getAvailableRejections(orderId, productId) {
    try {
      console.log('Frontend: Buscando rejeições disponíveis para:', { orderId, productId });

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar rejeições."
        );
      }

      console.log('Frontend: URL da chamada:', `/production/orders/${orderId}/items/${productId}/available-rejections`);
      const response = await axiosInstance.get(
        `/production/orders/${orderId}/items/${productId}/available-rejections`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar rejeições disponíveis"
        );
      }
      throw error;
    }
  },

  async undoLastChange(orderId, productId) {
    try {
      console.log('Frontend: Revertendo última alteração para:', { orderId, productId });

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para reverter alterações."
        );
      }

      console.log('Frontend: URL da chamada:', `/production/orders/${orderId}/items/${productId}/undo-last-change`);
      const response = await axiosInstance.post(
        `/production/orders/${orderId}/items/${productId}/undo-last-change`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao reverter última alteração"
        );
      }
      throw error;
    }
  },

  async getMonthlyProductionTotal() {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar o total de produção mensal."
        );
      }

      const response = await axiosInstance.get(`/production/total-monthly-production`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message ||
            "Erro ao buscar total de produção mensal"
        );
      }
      throw error;
    }
  },

  async getAverageConsumptionByProduct(productId, period) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar a média de consumo por produto."
        );
      }

      // Assumindo que o backend terá um endpoint para a média de consumo por produto
      const response = await axiosInstance.get(
        `/production/average-consumption-by-product`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { productId, period },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message ||
            "Erro ao buscar média de consumo por produto"
        );
      }
      throw error;
    }
  },

  // Funções para Rascunhos de Ordem de Produção
  async saveProductionOrderDraft(draftData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;
      if (!token) throw new Error("Usuário não autenticado.");

      const response = await axiosInstance.post(
        `/production/drafts`,
        draftData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Erro ao salvar rascunho."
      );
    }
  },

  async getProductionOrderDrafts() {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;
      if (!token) throw new Error("Usuário não autenticado.");

      const response = await axiosInstance.get(`/production/drafts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Erro ao buscar rascunhos."
      );
    }
  },

  async getProductionOrderDraftById(id) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;
      if (!token) throw new Error("Usuário não autenticado.");

      const response = await axiosInstance.get(`/production/drafts/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Erro ao obter rascunho."
      );
    }
  },

  async deleteProductionOrderDraft(id) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;
      if (!token) throw new Error("Usuário não autenticado.");

      const response = await axiosInstance.delete(
        `/production/drafts/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Erro ao excluir rascunho."
      );
    }
  },

  async checkCuringCompletion() {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para verificar a conclusão de cura."
        );
      }

      const response = await axiosInstance.get(
        `/production/check-curing-completion`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao verificar conclusão de cura"
        );
      }
      throw error;
    }
  },

  async getLotsHistory(productId) {
    try {
      console.log('Frontend: Buscando histórico de lotes do produto:', productId);

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar histórico de lotes."
        );
      }

      console.log('Frontend: URL da chamada:', `/production/products/${productId}/lots-history`);
      const response = await axiosInstance.get(
        `/production/products/${productId}/lots-history`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar histórico de lotes"
        );
      }
      throw error;
    }
  },

  async getProductionSuggestions() {
    try {
      console.log('Frontend: Buscando sugestões de produção');

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar sugestões de produção."
        );
      }

      console.log('Frontend: URL da chamada:', `/production/suggestions`);
      const response = await axiosInstance.get(
        `/production/suggestions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar sugestões de produção"
        );
      }
      throw error;
    }
  },

  async calculateProductionSuggestions(filters = {}) {
    try {
      console.log('Frontend: Calculando sugestões com filtros:', filters);

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para calcular sugestões."
        );
      }

      const response = await axiosInstance.post(
        `/production/suggestions/calculate`,
        filters,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao calcular sugestões de produção"
        );
      }
      throw error;
    }
  },

  async validateProductionSuggestion(productId, suggestedQuantity) {
    try {
      console.log('Frontend: Validando sugestão para produto:', productId);

      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para validar sugestões."
        );
      }

      const response = await axiosInstance.post(
        `/production/suggestions/validate`,
        { product_id: productId, suggested_quantity: suggestedQuantity },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao validar sugestão de produção"
        );
      }
      throw error;
    }
  },

  async splitProductionItem(orderId, itemId, kgToSplit) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;
      if (!token) throw new Error("Usuário não autenticado.");

      const response = await axiosInstance.post(
        `/production/orders/${orderId}/items/${itemId}/split`,
        { kg_to_split: kgToSplit },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || "Erro ao dividir item de produção");
      }
      throw error;
    }
  },

  async deleteProductionOrder(orderId) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para deletar ordem de produção."
        );
      }

      const response = await axiosInstance.delete(
        `/production/orders/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao deletar ordem de produção"
        );
      }
      throw error;
    }
  },
};
